export default __webpack_public_path__ + "static/media/MasseyCV.9fb8416e.pdf";